// extracted by mini-css-extract-plugin
export default {"add-note":"AddNoteOption__add-note--zDvBmSrjth","add-note__text":"AddNoteOption__add-note__text--JW3YKtHxfD"};